import React from 'react';
import Button from 'components/Button';
import { useFormikContext } from 'formik';

interface ResetButtonProps {}

// Note, only works with Formik
export const ResetButton: React.FC<ResetButtonProps> = ({ children }) => {
  const { resetForm, dirty } = useFormikContext();
  return (
    <Button
      type="reset"
      onClick={resetForm}
      disabled={!dirty}
      className="btn btn-white"
    >
      {children}
    </Button>
  );
};

export default ResetButton;
